import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import MainLayout from "./components/layout/MainLayout";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import WorkflowCenter from "./pages/WorkflowCenter";
import ToolPage from "./pages/ToolPage";
import History from "./pages/History";
import Login from "./pages/Login";
import AuditReport from "./pages/AuditReport";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Settings from "./pages/Settings";
import OrgJoin from "./pages/OrgJoin";
import ApiDocs from "./pages/ApiDocs";
import WorkflowDocs from "./pages/WorkflowDocs";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import StrategyMaps from "./pages/StrategyMaps";
import AdminPanel from "./pages/AdminPanel";
import { Privacy, Terms, Cookies, DPA } from "./pages/Legal";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback FIRST — detect synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/audit/:id" element={<AuditReport />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/org/join" element={<OrgJoin />} />
        <Route path="/docs/api" element={<ApiDocs />} />
        <Route path="/docs/workflow" element={<WorkflowDocs />} />
        <Route path="/docs/workflow-center" element={<WorkflowDocs />} />
        <Route path="/auth/forgot" element={<ForgotPassword />} />
        <Route path="/auth/reset" element={<ResetPassword />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/dpa" element={<DPA />} />

        <Route path="/settings" element={
          <ProtectedRoute><Settings /></ProtectedRoute>
        } />

        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/workflow" element={
          <ProtectedRoute><WorkflowCenter /></ProtectedRoute>
        } />
        <Route path="/strategy" element={ 
          <ProtectedRoute><StrategyMaps /></ProtectedRoute>
        } />
        <Route path="/tools/:tool" element={
          <ProtectedRoute><ToolPage /></ProtectedRoute>
        } />
        <Route path="/history" element={
          <ProtectedRoute><History /></ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute><AdminPanel /></ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
